<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Histórico de Notificações</span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="notifications"
          :items-per-page="10"
          :sort-by="['createdAt']"
          :sort-desc="true"
        >
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | date('DD/MM/YYYY HH:mm') }}
          </template>
          <template v-slot:[`item.channel`]="{ item }">
            <v-chip :color="item.channel === 'Email' ? 'info' : 'success'" label>
              {{ item.channel }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import rentalService from '@/services/rental'

export default {
  data() {
    return {
      dialog: false,
      payment: null,
      rental: null,
      notifications: [],
      headers: [
        { text: 'Data', value: 'createdAt' },
        { text: 'Canal', value: 'channel' },
        { text: 'Destino', value: 'destination' },
      ],
    }
  },
  methods: {
    open({ payment, rental }) {
      this.dialog = true
      this.payment = payment
      this.rental = rental
      this.getNotifications()
    },
    close() {
      this.dialog = false
      this.payment = null
      this.rental = null
      this.notifications = []
    },
    async getNotifications() {
      try {
        const { notifications } = await rentalService.payment.notifications(this.rental.id, this.payment.id)
        this.notifications = notifications
      } catch (e) {
        this.$toast.fire({
          title: e.message || 'Erro ao buscar histórico de notificações',
          icon: 'error',
        })
        this.close()
      }
    },
  },
  created() {
    this.$root.$on(this.componentName, this.open)
  },
  props: {
    componentName: {
      type: String,
      default: 'show-payment-history',
    },
    rental: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
iframe {
  border: none;
  width: 100%;
  height: calc(90vh - 200px);
}
</style>
